import { Button } from '@antimatterhq/ui/components/button';
import { useNavigateBackToPreviousRoute } from '@/hooks/nagivation/useNavigateBackToPreviousRoute';

export const BackLink = ({ fallbackRoute }: { fallbackRoute: string }) => {
  const navigate = useNavigateBackToPreviousRoute();

  return (
    <Button
      variant="link"
      leftIcon="lucide:chevron-left"
      className="px-0"
      onClick={() => navigate(fallbackRoute)}
    >
      Back
    </Button>
  );
};
